import * as Yup from "yup";

export const AddBlogSchema = Yup.object({
  title: Yup.string().required("Title is required"),
  description: Yup.string().required("Description is required"),
  status: Yup.object()?.nullable(),
  createdAt: Yup.string()?.nullable(),
  thumbnailImage: Yup.mixed().required("Blog thumbnail image is required"),
  bannerImage: Yup.mixed().required("Blog banner image is required"),
});
